// Slovenské dvojče locale/cs/serviceModel.js.
// SK: neověřeno ve fixtures — servisní stránka www.jipos.sk (dev/sk/service.html)
// má jinou strukturu obsahu (kontaktní formulář bez sekcí „Čo ponúkame"/„Cenník"/
// „Prečo"), takže nadpisové a cenové regexy níže nejdou ověřit proti reálnému
// obsahu; jsou to slovenské tvary CZ vzoru pro případ, že admin obsah doplní.
export default {
  eyebrow: 'Servisné stredisko Jipos',
  spec: 'Špecializácia na:',
  pricePerex:
    'Ceny sú orientačné a platia ako „od". Konečnú cenu vám povieme po diagnostike; v prípade výmeny dielu zodpovedá cena cene výmeny.',
  bandTitle: 'Potrebujete opraviť náradie?',
  bandText: 'Napíšte alebo prineste náradie na predajňu v Bíline. Diagnostikujeme závadu a vopred oznámime cenu aj termín.',

  headingServicesRe: /čo ponúkame/i,
  headingPricingRe: /cenník/i,
  headingWhyRe: /prečo/i,

  specializeRe: /(š?)peciali[sz]/i,

  priceWordRe: /\s*\b(?:(za\s+cenu|za|od|cca|už\s+od)\s+)(\d[\d\s]*€)\.?$/i,
  wordFrom: 'od',
  wordAlreadyFrom: 'už od',
  wordCca: 'cca',
  prefixFrom: 'od ',
  prefixCca: 'cca ',
  pricingValueRe: /(?:\b(od|cca)\s+)?(\d[\d\s]*€)/i,

  freeSuffixRe: /\s*[-–—:]\s*(zadarmo)\.?$/i,
  freeLabel: 'Zadarmo',

  // SK: neověřeno ve fixtures — slovenský překlad CZ klíčových slov
  serviceIcons: [
    [/diagnost/i, 'cog'],
    [/výmen/i, 'refresh'],
    [/brúse.*(nôž|nože)|nôž|nože/i, 'leaf'],
    [/brúse|reťaz/i, 'bolt'],
    [/údržb/i, 'wrench'],
    [/diel|oprav/i, 'package'],
    [/rad|tip/i, 'headset'],
  ],
  priceIcons: [
    [/kosač/i, 'leaf'],
    [/píl|krovinorez/i, 'bolt'],
    [/drvič|kultivátor|fréz/i, 'cog'],
  ],
  whyIcons: [
    [/rýchl/i, 'bolt'],
    [/skúsen|prax/i, 'rosette'],
    [/záruk|kvalit/i, 'shield'],
    [/cen|poplat/i, 'tag'],
  ],
};
